import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import IconPlus from 'cccisd-icons/plus-circle2';
import SupervisorForm from 'js/components/SupervisorForm';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;
const Fortress = window.cccisd && window.cccisd.fortress;

const AddSupervisor = props => {
    const modal = useRef();
    const currentRole = Fortress.user && Fortress.user.acting.role.handle;
    const isSupervisor = currentRole === 'supervisor';

    const onSubmit = async values => {
        const response = await axios.post(Boilerplate.route('api.nexus.pawn.store'), {
            role: 'supervisor',
            user: values.existingUser ? values.email : undefined,
            username: values.existingUser ? undefined : values.email,
            first_name: values.firstName,
            last_name: values.lastName,
            email: values.email,
            administerPageAccess: values.administerPageAccess,
            dashboardPageAccess: values.dashboardPageAccess,
            managePageAccess: values.managePageAccess,
            group: values.site,
        });

        if (response.data.errors) {
            let errorMessage = response.data.errors;
            if (typeof response.data.errors === 'object') {
                errorMessage = Object.values(response.data.errors).flat().join(' ');
            }
            notification({ type: 'danger', message: errorMessage });
            return Promise.reject(response.data.errors);
        }

        await props.loadData();
        await modal.current.close();
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <button type="button" className="btn btn-primary">
                    <IconPlus spaceRight />
                    Add Supervisor
                </button>
            }
            title="Add New Supervisor"
        >
            <SupervisorForm
                onSubmit={onSubmit}
                isEdit={false}
                initialValues={{
                    firstName: '',
                    lastName: '',
                    email: '',
                    adminId: '',
                    phoneNumber: '',
                    enrolledInSmartwrap: false,
                    administerPageAccess: true,
                    dashboardPageAccess: true,
                    managePageAccess: true,
                    site: isSupervisor && Fortress?.user?.acting?.group?.id ? [Fortress.user.acting.group.id] : [],
                }}
            />
        </Modal>
    );
};

AddSupervisor.propTypes = {
    loadData: PropTypes.func,
};

export default AddSupervisor;
